document.addEventListener("DOMContentLoaded", function() {
    const shippingDateInput = document.getElementById("shippingDate");
    const saveButton = document.getElementById("saveShippingDate");
    const saveMessage = document.getElementById("saveMessage");

    if (shippingDateInput) {
      flatpickr(shippingDateInput, {
        dateFormat: "d-m-Y",             // ✅ German-style format
        minDate: new Date().fp_incr(1),  // ✅ tomorrow
        defaultDate: new Date().fp_incr(1),
        locale: "de",                    // ✅ use German locale (from added script)
        disable: [
          function(date) {
            return date.getDay() === 0; // disable Sundays
          }
        ]
      });
    }

    saveButton.addEventListener("click", function () {
        const selectedDate = shippingDateInput.value;

        fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                attributes: {
                    shipping_date: selectedDate
                }
            })
        })
        .then(response => response.json())
        .then(cart => {
            saveMessage.textContent = "Date saved successfully!";
            saveMessage.style.display = "block";
            setTimeout(() => saveMessage.style.display = "none", 2000);
        })
        .catch(error => {
            console.error("Error saving shipping date:", error);
            saveMessage.textContent = "Error saving date.";
            saveMessage.style.color = "red";
            saveMessage.style.display = "block";
        });
    });
});
